import { get, getOr } from 'lodash/fp';
import { createStructuredSelector, createSelector } from 'reselect';

import { isEmailSubscriptionWidgetFeature } from 'modules/features';

const getShowEmailSubscriptionWidget = (state, props) =>
  getOr(true, ['withEmailSubscriptionWidget'], props) &&
  isEmailSubscriptionWidgetFeature;

const getExperimentId = (state, props) => get(['experiment', 'id'], props);

const getExperimentVariant = createSelector(
  (state, props) => get(['experiment', 'winnerVariant'], props),
  (expVar) => (typeof expVar !== 'undefined' ? expVar.toString() : null),
);

export default createStructuredSelector({
  headerCmsData: get(['layout', 'cms', 'result']),
  isLoaded: get(['layout', 'cms', 'isLoaded']),
  footerProps: get(['layout', 'footer', 'result']),
  showEmailSubscriptionWidget: getShowEmailSubscriptionWidget,
  expId: getExperimentId,
  expVar: getExperimentVariant,
});
